import handleArrowKeyPress from 'mini-accessibility/lib/utils/handleKeyArrowPress';
import React from 'react';
import { isDevToolsEnabled } from '../utils/isDevToolsEnabled';

const styles = require('./DiagnosticsTrigger.scss');

interface DiagnosticsBootProps {
    onClick: () => void;
    startIndex?: number;
    itemRefs?: React.RefObject<any>[];
    totalLength?: number;
}

const DiagnosticsTrigger = (props: DiagnosticsBootProps) => {
    if (!isDevToolsEnabled()) {
        return null;
    }

    const setKeyConfig = {
        itemIndex: props.startIndex,
        itemRefs: props.itemRefs,
        length: props.totalLength,
    };

    return (
        <div
            tabIndex={0}
            className={styles.entryItem}
            role="button"
            onKeyUp={e => {
                if (e.key !== 'Enter') {
                    return;
                }
                props.onClick();
            }}
            onClick={props.onClick}
            ref={props.startIndex && props.itemRefs ? props.itemRefs[props.startIndex] : undefined}
            onKeyDown={handleArrowKeyPress(setKeyConfig)}>
            Diagnostics
        </div>
    );
};

export default DiagnosticsTrigger;
